export default "__VITE_ASSET__2Lw8nb_0__"